<template>
  <div class="search-actions">
    <div class="action-btns">
      <TolButton
        button-type="minor"
        icon-name="file-pdf"
        class="action-round"
        :tooltip="$t('advancedSearch.actions.printToPdf')"
        @click="doPdfPrint()"
      />

      <TolButton
        v-click-outside="() => (displayExportOptions = false)"
        button-type="minor"
        icon-name="file-excel"
        class="action-round"
        :tooltip="$t('advancedSearch.actions.exportToExcel')"
        @click="displayExportOptions = !displayExportOptions"
      />
      <Dropdown
        v-if="displayExportOptions"
        :menu-items="[
          { label: $t('advancedSearch.actions.exportAll') },
          { label: $t('advancedSearch.actions.exportPage') }
        ]"
        class="dropdown-menu-right right-anchored"
        @optionClicked="onMenuOptionSelected($event)"
      />
    </div>
  </div>
</template>

<script>
import TolButton from '@/app/components/TolButton';
import Dropdown from '@/app/components/Dropdown';
import vClickOutside from 'v-click-outside';

import { AdvancedSearchActions } from '@/app/features/advanced-search/advanced-search.keys';
export default {
  name: 'SearchExportActions',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    TolButton,
    Dropdown
  },
  data() {
    return {
      displayExportOptions: false
    };
  },
  methods: {
    doPdfPrint() {},
    onMenuOptionSelected(val) {
      this.displayExportOptions = false;
      this.$store.dispatch(AdvancedSearchActions.DownloadSearchResultsAsExcel, val.menuOption);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors';
@import '@/app/styles/variables';

.search-actions {
  display: flex;
  padding: 60px;
  background-color: $background-level-2;

  .action-btns {
    margin-left: auto;
    position: relative;
  }
}

.right-anchored {
  right: 0;
}
</style>
